module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/0-bg-d6c127327093b92704c23c639492398b.png";